export const addFuelTypeEndpoint = () =>(`/api/fuel-type`);

export const editFuelTypeEndpoint = (fuelTypeId: string) =>
 (`/api/fuel-type/${fuelTypeId}`);

export const getFuelTypeEndpoint = () =>(`/api/fuel-type`);

export const getFuelTypeDetailsEndpoint = (fuelTypeId: string) =>
 (`/api/fuel-type/${fuelTypeId}`);

export const deleteFuelTypeEndpoint = (fuelTypeId: string) =>
 (`/api/fuel-type/${fuelTypeId}`);
